import types from './types'

const disableFilter = (name) => ({
  type: types.VISIT_TYPE_FILTER_HIDE,
  payload: name,
})
const enableFilter = (name) => ({
  type: types.VISIT_TYPE_FILTER_SHOW,
  payload: name,
})
const changeFilter = (name, value) => ({
  type: types.VISIT_TYPE_FILTER_CHANGE,
  payload: {
    name,
    value,
  },
})
export default {
  disableFilter,
  enableFilter,
  changeFilter,
}
